import { FC, useEffect } from 'react';
import { RuleLine } from '@marriott/mi-ui-library';
import { InventoryInfoProps } from './InventoryInfo.types';
import { StyledInventoryInfo } from './InventoryInfo.styles';
import { useReslinkGuestStore } from '../../store';
import { updateDataLayerWithInventoryAttributes } from '../../utils';

export const InventoryInfo: FC<InventoryInfoProps> = ({ description, startDate, endDate }) => {
  const { isReslinkBlockFull, isMissingInventory } = useReslinkGuestStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (isMissingInventory && !params.has('inventoryMissing')) params.set('inventoryMissing', 'true');
    if (isReslinkBlockFull && !params.has('blockFull')) params.set('blockFull', 'true');
    if (isMissingInventory || isReslinkBlockFull) {
      window.history.replaceState({}, '', `?${params.toString()}`);
      updateDataLayerWithInventoryAttributes(params.toString());
    }

    return () => {
      params.delete('inventoryMissing');
      params.delete('blockFull');
      window.history.replaceState({}, '', `?${params.toString()}`);
      updateDataLayerWithInventoryAttributes(params.toString());
    };
  }, [isMissingInventory, isReslinkBlockFull]);

  return (
    <StyledInventoryInfo>
      <div className="inventory-content" id="inventory-info"  data-component-name="m-groups-inventoryInfo">
        <div className="t-font-s t-font-weight-b">{description}</div>
        <div className="date-section">
          <span className="icon-stay-dates"></span>
          <span className="t-font-s">
            {startDate} - {endDate}
          </span>
        </div>
      </div>

      <div className="mt-2">
        <RuleLine styleclass="ruler-length-100" />
      </div>
    </StyledInventoryInfo>
  );
};
